import {
  DataRoomShareableLink,
  ShareableLinkMainInfo,
} from 'models/ShareableLink';
import httpClient from '../httpClient';
import { LinkExpiredFormValues } from '../../components/ShareableLinkHasExpired/ShareableLinkHasExpired.component';

function getShareableLinkMainInfo(
  shareableLinkId: string,
  authorizationToken?: string,
  emailToken?: string,
) {
  return httpClient.get<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/main-info`,
    {
      params: { authorizationToken, emailToken },
    },
  );
}

function login(
  shareableLinkId: string,
  email: string,
  firstName: string,
  lastName?: string,
  companyName?: string,
) {
  return httpClient.post(`shareable-links/${shareableLinkId}/login`, {
    email,
    firstName,
    lastName,
    companyName,
  });
}

function updateShareableLinkUser(
  shareableLinkId: string,
  email: string,
  firstName: string,
  lastName?: string,
  companyName?: string,
) {
  return httpClient.post<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/update-shareable-link-user`,
    {
      email,
      firstName,
      lastName,
      companyName,
    },
  );
}

function confirmTwoFactor(
  shareableLinkId: string,
  email: string,
  code: string,
) {
  return httpClient.post<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/confirm-2fa`,
    {
      email,
      code,
    },
  );
}

function requestAccessForExpiredLink(
  shareableLinkId: string,
  values: LinkExpiredFormValues,
) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-access-for-expired`,
    values,
  );
}

function requestAccess(shareableLinkId: string, email: string) {
  return httpClient.post(`shareable-links/${shareableLinkId}/request-access`, {
    email,
  });
}

function requestAccessReminder(shareableLinkId: string, email: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-access-reminder`,
    {
      email,
    },
  );
}

function requestPassword(shareableLinkId: string, email: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-password`,
    {
      email,
    },
  );
}

function requestPasswordReminder(shareableLinkId: string, email: string) {
  return httpClient.post(
    `shareable-links/${shareableLinkId}/request-password-reminder`,
    {
      email,
    },
  );
}

function confirmPassword(
  shareableLinkId: string,
  email: string,
  password: string,
) {
  return httpClient.post<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/confirm-password`,
    {
      email,
      password,
    },
  );
}

function sendPassword(shareableLinkId: string, emailToken: string) {
  return httpClient.post(`shareable-links/${shareableLinkId}/send-password`, {
    emailToken,
  });
}

function getShareableLink(shareableLinkId: string) {
  return httpClient.get<DataRoomShareableLink>(
    `shareable-links/${shareableLinkId}`,
  );
}

function getNDADocusignUrl(shareableLinkId: string) {
  return httpClient.get<{ url: string }>(
    `data-room-ndas/shareable-links/${shareableLinkId}/docusign-url`,
  );
}

function acceptTermsAndConditions(shareableLinkId: string) {
  return httpClient.post<ShareableLinkMainInfo>(
    `shareable-links/${shareableLinkId}/accept-terms-and-conditions`,
  );
}

export default {
  getShareableLinkMainInfo,
  login,
  updateShareableLinkUser,
  confirmTwoFactor,
  requestAccessForExpiredLink,
  requestAccess,
  requestAccessReminder,
  confirmPassword,
  requestPassword,
  requestPasswordReminder,
  sendPassword,
  getShareableLink,
  getNDADocusignUrl,
  acceptTermsAndConditions,
};
